import React from "react";
// import "./Home.css"; // Keep your animations and custom styles here

import heroImage from "../../assets/images/automobile-2861859_1280.jpg"; // Hero background image

const Hero = () => {
  return (
    <main className="pt-[113px] bg-white text-gray-800">
      {/* Hero Section */}
      <section className="relative h-screen overflow-hidden">
        {/* Background Image */}
        <img
          src={heroImage}
          alt="Hero Background"
          className="absolute top-0 left-0 w-full h-full object-cover z-0"
          style={{ opacity: '85%' }}
        />

        {/* Gradient Overlay */}
        <div className="absolute top-0 left-0 w-full h-full z-10 bg-gradient-to-r from-black/70 via-black/40 to-transparent"></div>

        {/* Content Overlay */}
        <div className="relative z-20 h-full flex items-center text-white px-6 md:px-10">
          <div className="max-w-8xl mx-auto flex flex-col md:flex-row items-center gap-10 w-full">
            <div className="md:w-1/2 animate-fade-in">
              <h1
                className="text-4xl md:text-7xl font-bold leading-tight mb-6"
                style={{ width: 'max-content', color: '#E7DFC6' }}
              >
                About Us 
              </h1>
              <p
                className="text-4xl mb-6"
                style={{ width: 'max-content', color: '#E9F1F7' }}
              >
                We Are Engaged As A Service Provider Of CED And Powder Coating Services <br/> On All Metal Surfaces
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
};

export default Hero;
